import { useNavigationType } from "react-router-dom";

const useNavigationSource = () => {
  const navigationType = useNavigationType();

  // if navigation happened directly from the URL/browser refresh
  const isDirectNavigation = navigationType === "POP";
  // if navigation happened within the app
  const isInAppNavigation = navigationType === "PUSH";
  // if navigation replaced the current route, without adding a new entry to the browser history
  // navigate('/dashboard', { replace: true }); or <Navigate to="/path" replace />
  const isReplaceNavigation = navigationType === "REPLACE";

  return {
    navigationType,
    isDirectNavigation,
    isInAppNavigation,
    isReplaceNavigation,
  };
};

export default useNavigationSource;
